module.exports = __webpack_public_path__ + "img/j4.3e2f0bd8.webp";